import { useQuery } from '@tanstack/react-query';
import { api } from 'apis/fetch';
import * as keys from './keys';

import type { ISubmissionEvent } from 'utils/constants';
import { RawSubmission } from '../../apis/submissions';
import { queryClient } from '../../apis/client';

type SubmissionEventsResponse = {
  submissionEvents: (ISubmissionEvent & { submission: RawSubmission })[];
};

type ProcessedSubmissionEventsResponse = {
  events: ISubmissionEvent[];
};

interface SubmissionOpts {
  disabled?: boolean;
}

const STALE_TIME = 1000;

export const useSubmissionEvents = (submissionId: string, opts?: SubmissionOpts) => {
  return useQuery({
    enabled: !!submissionId && !opts?.disabled,
    queryKey: keys.events(submissionId),
    queryFn: async ({ signal }): Promise<ProcessedSubmissionEventsResponse> => {
      const resp = await api<SubmissionEventsResponse>(`/submission/${submissionId}/event`, { signal });
      return {
        events: resp.submissionEvents.map((event) => ({
          ...event,
          date: new Date(event.date),
        })),
      };
    },
    staleTime: STALE_TIME,
  });
};

export const invalidateSubmissionEvents = (submissionId?: string) => {
  if (!submissionId) return;
  return queryClient.invalidateQueries({ queryKey: keys.events(submissionId) });
};
